module.exports = __webpack_public_path__ + "img/dhl_charge_logo.e5d417e5.png";